import { useEffect, useState } from 'react';
import supabase from '../supabase/supabase';
import { GALLERY_TABLE, GALLERY_DEFAULTS } from '../data/imageSlots';

let cache = null;

async function load() {
  const { data, error } = await supabase.from(GALLERY_TABLE).select('*').order('sort_order');
  if (error) return GALLERY_DEFAULTS;
  return data || [];
}

export function useGallery() {
  const [items, setItems] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    load().then((data) => { cache = data; setItems(data); }).catch(() => {});
  }, []);
  return { items };
}